// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"ebae65dd","769":"6485582d"}[chunkId] + ".chunk.css";
};